// extracted by mini-css-extract-plugin
export default {"pic":"ImageSlider_pic__BREVx","notice":"ImageSlider_notice__5Ka98","animate":"ImageSlider_animate__5r-NO","notis-an":"ImageSlider_notis-an__Y4nJt"};